import React from "react";
import { Box, Grid, Slide, Typography, CardMedia } from "@mui/material";
import { SecondaryStyle } from "../fonts";

import LB from "../assets/Page8LB.webp";
import LD from "../assets/Page8LD.webp";
import LAB from "../assets/Page8LAB.webp";
import LAT from "../assets/Page8LAT.webp";

//@ts-ignore
import LC from "../assets/Page8LC.mp4";
//@ts-ignore
import RB from "../assets/Page8RB.mp4";

const Page8 = (props) => {
  const { checked, isReverse } = props;

  return (
    <Slide
      direction={isReverse ? "right" : "left"}
      in={checked}
      timeout={{
        enter: 1750,
        exit: 1750,
      }}
    >
      <Box
        sx={{
          width: "100vw",
          height: "100vh",
          overflow: { xs: "auto", sm: "hidden" },
        }}
      >
        <Grid container sx={{ height: "100%" }} id="scrollTarget">
          {/* First Half */}
          <Grid item xs={12} sm={6}>
            <Grid
              container
              direction={{ xs: "row", sm: "column" }}
              sx={{ height: "100%" }}
            >
              {/* LA/LD */}
              <Grid item xs={12} sm={6}>
                <Grid container direction={"row"} sx={{ height: "100%" }}>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    sx={{
                      height: {
                        xs: "45vh",
                        sm: "100%",
                      },
                      borderTop: {
                        xs: "1vh solid #fff",
                        sm: "none",
                      },
                      borderBottom: ".5vh solid #fff",
                      borderRadius: { xs: "16px", sm: "0vh" },
                      borderRight: {
                        xs: "1vh solid #fff",
                        sm: ".5vh solid #fff",
                      },
                      borderLeft: {
                        xs: "1vh solid #fff",
                        sm: "none",
                      },
                      backgroundImage: `url('${LD}')`,
                      backgroundRepeat: "no-repeat",
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                    }}
                  />

                  {/**LB */}
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    sx={{
                      borderTop: {
                        xs: ".5vh solid #fff",
                        sm: "none",
                      },
                      borderRight: {
                        xs: "1vh solid #fff",
                        sm: ".5vh solid #fff",
                      },
                      borderLeft: {
                        xs: "1vh solid #fff",
                        sm: ".5vh solid #fff",
                      },
                      maxHeight: { xs: "91.5vh", sm: "50vh" },
                      height: { xs: "91.5vh", sm: "100%" },
                    }}
                  >
                    <Box
                      sx={{
                        boxSizing: "border-box",
                        height: { xs: "45vh", sm: "25vh" },
                        borderRadius: { xs: "16px", sm: "0vh" },
                        borderBottom: {
                          xs: ".5vh solid #fff",
                          sm: ".5vh solid #fff",
                        },
                        backgroundImage: `url('${LAT}')`,
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                      }}
                    />
                    <Box
                      sx={{
                        height: { xs: "45.5vh", sm: "24.5vh" },
                        boxSizing: "border-box",
                        borderRadius: { xs: "16px", sm: "0vh" },
                        borderTop: ".5vh solid #fff",
                        backgroundImage: `url('${LAB}')`,
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12} sm={6}>
                <Grid
                  container
                  direction={"row"}
                  sx={{
                    height: "100%",
                    width: "100%",
                    maxHeight: { xs: "100%", sm: "50vh" },
                  }}
                >
                  {/* LC */}
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    sx={{
                      borderTop: ".5vh solid #fff",
                      borderBottom: {
                        xs: ".5vh solid #fff",
                        sm: "none",
                      },
                      borderRight: {
                        xs: "1vh solid #fff",
                        sm: ".5vh solid #fff",
                      },
                      borderLeft: {
                        xs: "1vh solid #fff",
                        sm: "none",
                      },
                      borderRadius: { xs: "16px", sm: "0vh" },
                      height: { xs: "46vh", sm: "50vh" },
                    }}
                  >
                    <CardMedia
                      component={"video"}
                      sx={{
                        borderRadius: { xs: "16px", sm: "0vh" },
                        height: {
                          xs: "45vh",
                          sm: "100%",
                        },
                        maxHeight: "50vh",

                        objectFit: "cover",
                      }}
                      src={LC}
                      playsInline
                      autoPlay
                      muted
                      loop
                    />
                  </Grid>

                  {/* LB */}
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    sx={{
                      height: { xs: "45vh", sm: "100%" },
                      borderTop: ".5vh solid #fff",
                      borderBottom: {
                        xs: ".5vh solid #fff",
                        sm: "none",
                      },
                      borderRight: {
                        xs: "1vh solid #fff",
                        sm: ".5vh solid #fff",
                      },
                      borderLeft: {
                        xs: "1vh solid #fff",
                        sm: ".5vh solid #fff",
                      },
                      borderRadius: { xs: "16px", sm: "0vh" },
                      backgroundImage: `url('${LB}')`,
                      backgroundRepeat: "no-repeat",
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} sm={6}>
            <Grid
              container
              direction={{ xs: "row", sm: "column" }}
              sx={{ height: "100%" }}
            >
              <Grid item xs={12}>
                <Grid
                  container
                  direction={"row"}
                  sx={{
                    height: "100%",
                  }}
                >
                  {/* RD/RA */}
                  <Grid
                    container
                    direction={"row"}
                    sx={{
                      height: "100%",
                    }}
                  >
                    {/* RD */} {/* RA */}
                    <Grid
                      item
                      xs={12}
                      sx={{
                        borderRadius: { xs: "16px", sm: "0vh" },

                        borderTop: {
                          xs: ".5vh solid #fff",
                          sm: "none",
                        },
                        borderLeft: {
                          xs: "1vh solid #fff",
                          sm: ".5vh solid #fff",
                        },
                        borderRight: { xs: "1vh solid #fff", sm: "none" },

                        borderBottom: {
                          xs: ".5vh solid #fff",
                        },

                        height: { xs: "45vh", sm: "100%" },
                        maxHeight: "50vh",
                      }}
                    >
                      <CardMedia
                        component={"iframe"}
                        allowFullScreen
                        loading="eager"
                        title="Embedded Street View"
                        referrerPolicy="no-referrer-when-downgrade"
                        sx={{
                          border: 0,
                          height: "100%",
                          width: "100%",
                          objectFit: "cover",
                          borderRadius: { xs: "16px", sm: "0vh" },
                        }}
                        src="https://www.google.com/maps/embed?pb=!4v1726644156513!6m8!1m7!1s7uZBPbEuvixjlRKa-O4Kjg!2m2!1d43.66461751354236!2d-79.41372024149696!3f76.39!4f1.8199999999999932!5f0.7820865974627469"
                      />
                    </Grid>
                    {/**RC */}
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      sx={{
                        px: { xs: 1.5, md: 1.5, lg: 2, xl: 3 },
                        pb: { xs: 1.5 },
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <Typography
                        sx={{
                          ...SecondaryStyle,

                          textAlign: { xs: "justify", sm: "left" },
                          "@media (orientation: landscape)": {
                            fontSize: { xs: "1vw", md: "1vw", lg: "1vw" },
                            lineHeight: {
                              xs: "1.2vw",
                              md: "1.3vw",
                              lg: "1.35vw",
                            },
                          },
                          "@media (orientation: portrait)": {
                            fontSize: { xs: "1.7vh", sm: "1vh" },
                            lineHeight: {
                              xs: "2vh",
                              sm: "1.5vh",
                              md: "1.5vh",
                              lg: "1.5vh",
                            },
                            paddingTop: {
                              xs: "1vh",
                              sm: "2vh",
                              md: "2vh",
                              lg: "2vh",
                            },
                          },
                        }}
                      >
                        Step into Seaton Village, a family-friendly neighborhood
                        where community and city living blend perfectly. Picture
                        weekend strolls along Bloor Street, where local shops
                        and cozy cafés bring neighbors together, and flower
                        vendors add a splash of color. Families gather at
                        Christie Pits Park for playground fun, sports, and
                        picnics, while the nearby library offers spaces for
                        learning and connection. With the Bathurst subway just
                        steps away, enjoy the vibrant city while feeling right
                        at home in this close-knit community.
                      </Typography>
                    </Grid>
                    {/* RC */}
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      sx={{
                        borderTop: {
                          xs: ".5vh solid #fff",
                          sm: ".5vh solid #fff",
                        },

                        borderBottom: {
                          xs: "1vh solid #fff",
                          sm: "none",
                        },
                        borderLeft: {
                          xs: "1vh solid #fff",
                          sm: ".5vh solid #fff",
                        },
                        borderRight: {
                          xs: "1vh solid #fff",
                          sm: "none",
                        },

                        height: {
                          xs: "46.5vh",
                          sm: "50vh",
                        },
                      }}
                    >
                      <CardMedia
                        component={"video"}
                        sx={{
                          borderRadius: { xs: "16px", sm: "0vh" },
                          height: {
                            xs: "45vh",
                            sm: "100%",
                          },
                          maxHeight: "50vh",

                          objectFit: "cover",
                        }}
                        src={RB}
                        playsInline
                        autoPlay
                        muted
                        loop
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </Slide>
  );
};

export default Page8;
